import { Deserializable } from '../deserializable';

export class UpdateDocumentRequest implements Deserializable {
  documentType: number;
  idNumber: string;
  downloadLink: string;
  status: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
